import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Briefcase", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" pts ")
const _hoisted_4 = { class: "w-full py-3 px-7" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Add Case")

import ScorecardSection from './ScorecardSection.vue';
import { computed, ref } from 'vue';
import PotentialScore from './PotentialScore.vue';
import TextField from '../Inputs/TextField.vue';
import { useVModels } from '@vueuse/core';
import Button from '../UI/Button.vue';

interface Props {
  briefcases: Array<string>;
  briefcasePoints: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    briefcases: null,
    briefcasePoints: null
  },
  setup(__props: any) {

const props = __props as {
  briefcases: Array<string>;
  briefcasePoints: number;
}



const { briefcases, briefcasePoints: points } = useVModels(props);

const score = computed(() => points.value * briefcases.value.length);

const newCase = ref('');
function addCase() {
  if (newCase.value.length && !briefcases.value.includes(newCase.value)) {
    briefcases.value.push(newCase.value);
    newCase.value = '';
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScorecardSection, { title: "Briefcase Cash Ins" }, {
    info: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            class: "ml-1",
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(points) ? (points).value = $event : null))
          }, null, 512), [
            [_vModelText, _unref(points)]
          ]),
          _hoisted_3
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(briefcases).join(', ')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextField, {
            modelValue: newCase.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newCase).value = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["modelValue"]),
          _createVNode(Button, { onClick: addCase }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(PotentialScore, { score: _unref(score) }, null, 8, ["score"])
    ]),
    _: 1
  }))
}
}

})